import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Reveal, SectionTag } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls =
  "w-full bg-[#0A0A12] border border-white/15 rounded-lg px-5 py-4 text-sm text-white placeholder:text-white/30 focus:outline-none focus:border-[#007AFF] transition-colors duration-300";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", venue: "Entertainment Center", message: "" });
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast.error("Please add your name and email.");
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/inquiries`, form);
      toast.success("Enquiry sent — our team will be in touch within 24 hours.");
      setForm({ name: "", email: "", venue: "Entertainment Center", message: "" });
    } catch (err) {
      toast.error("Something went wrong sending your enquiry. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contact" data-testid="contact-section" className="py-28 md:py-40 bg-[#0B1120] border-t border-white/[0.06]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-16 lg:gap-24">
        <Reveal>
          <SectionTag number="03" label="Get Started" />
          <h2 className="font-heading font-extrabold tracking-tighter text-4xl sm:text-5xl lg:text-6xl">
            Ready to transform <span className="text-[#00D4FF]">your facility?</span>
          </h2>
          <p className="mt-8 text-white/55 leading-relaxed max-w-md">
            From concept to launch, we handle it all — so you can focus on
            growing your business.
          </p>
          <div className="mt-12 space-y-4 font-mono-pv text-xs uppercase tracking-[0.2em] text-white/40">
            <p>Concept to Launch / Fully Managed</p>
            <p>Dedicated Onboarding / Training / 24-7 Support</p>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <form onSubmit={submit} data-testid="contact-form" className="space-y-5">
            <div className="grid sm:grid-cols-2 gap-5">
              <input
                data-testid="contact-input-name"
                className={inputCls}
                placeholder="Your name"
                value={form.name}
                onChange={set("name")}
              />
              <input
                data-testid="contact-input-email"
                type="email"
                className={inputCls}
                placeholder="Email address"
                value={form.email}
                onChange={set("email")}
              />
            </div>
            <select data-testid="contact-select-venue" className={inputCls} value={form.venue} onChange={set("venue")}>
              <option>Entertainment Center</option>
              <option>Sports Bar / Restaurant</option>
              <option>Cinema</option>
              <option>Other</option>
            </select>
            <textarea
              data-testid="contact-input-message"
              rows={5}
              className={inputCls}
              placeholder="Tell us about your space and goals..."
              value={form.message}
              onChange={set("message")}
            />
            <button
              type="submit"
              disabled={sending}
              data-testid="contact-submit-button"
              className="w-full px-8 py-4 rounded-full bg-[#007AFF] text-white font-heading font-semibold text-sm hover:bg-[#00D4FF] hover:text-[#05050A] transition-colors duration-300 shadow-[0_0_40px_rgba(0,122,255,0.4)] disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {sending ? "Sending..." : "Request a Consultation"}
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
}
